import React from "react"
import { Image } from "@chakra-ui/image"
import { useTheme } from "@chakra-ui/system"
import { Box, Flex, Center, AspectRatio } from "@chakra-ui/layout"
import { useBreakpointValue } from "@chakra-ui/react"

import { CompetitorCopy } from "./resources/_copy-template"
import ResponsiveBlock from "~components/shared/layout/responsive-block"
import Paragraph from "../../shared/text/paragraph"
import SectionHeading from "../../shared/text/heading"

interface Props {
    companyName: string
    copy: CompetitorCopy["landing"]
}

const CompareLanding: React.FC<Props> = ({ companyName, copy }) => {
    const theme = useTheme()
    const imageSrc = useBreakpointValue({
        base: copy.mobileImage,
        md: copy.desktopImage,
    })

    return (
        <>
            <Box position="relative" pb={{ base: 24, lg: 32 }}>
                <Box
                    position="absolute"
                    bottom={0}
                    left={0}
                    right={0}
                    clipPath="polygon(0 0, 0 100%, 100% 100%, 100% 0)"
                    bgGradient={`radial-gradient(51.67% 50% at 50% -15%, ${theme.colors.gray[200]}, ${theme.colors.gray[100]}, ${theme.colors.white})`}
                    h={{ base: 24, lg: 32 }}
                />
                <Flex
                    w="full"
                    bgGradient={`radial-gradient(51.67% 50% at 50% 85%, ${theme.colors.gray[200]}, ${theme.colors.gray[100]}, ${theme.colors.white})`}
                    align="center"
                    justify="center"
                    pos="relative"
                >
                    <ResponsiveBlock pt={{ base: 24, lg: 32 }} mb={0}>
                        <Center flexDir="column" color="gray.900">
                            <SectionHeading
                                as="h1"
                                fontWeight="black"
                                size={{ base: "2xl", lg: "3xl", "2xl": "4xl" }}
                                textAlign="center"
                            >
                                Why choose
                            </SectionHeading>
                            <SectionHeading
                                mb={6}
                                as="h1"
                                fontWeight="black"
                                size={{ base: "2xl", lg: "3xl", "2xl": "4xl" }}
                                textAlign="center"
                            >
                                <Box
                                    as="span"
                                    bgClip="text"
                                    bgGradient="linear(to-br, brand.400, success.500)"
                                >
                                    Chckvet
                                </Box>{" "}
                                over{" "}
                                <Box
                                    as="span"
                                    bgClip="text"
                                    bgGradient={copy.gradientString}
                                >
                                    {companyName}
                                </Box>
                                ?
                            </SectionHeading>
                            <Paragraph
                                fontSize={{ base: "sm", lg: "md", "2xl": "lg" }}
                                textAlign="center"
                            >
                                {copy.subtitle}
                            </Paragraph>
                        </Center>
                        <AspectRatio
                            ratio={{ base: 1, md: 2.56 }}
                            w="full"
                            mt={12}
                        >
                            <Box w="full" h="full">
                                <Image
                                    src={imageSrc}
                                    alt={`Chckvet vs ${companyName}`}
                                    objectFit="contain"
                                    w="full"
                                    h="full"
                                />
                            </Box>
                        </AspectRatio>
                    </ResponsiveBlock>
                </Flex>
            </Box>
        </>
    )
}

export default CompareLanding
